// useSessionTimeout.js
import { useEffect, useRef } from "react";

const useSessionTimeout = (onTimeout, timeoutDuration = 15 * 60 * 1000) => {
  const timeoutId = useRef();
  useEffect(() => {
    const resetTimer = () => {
      clearTimeout(timeoutId.current);
      timeoutId.current = setTimeout(onTimeout, timeoutDuration);
    };

    const events = ["mousemove", "keydown", "scroll", "click"];

    for (const event of events) {
      window.addEventListener(event, resetTimer);
    }

    resetTimer(); // Start timer initially

    return () => {
      clearTimeout(timeoutId.current);
      for (const event of events) {
        window.removeEventListener(event, resetTimer);
      }
    };
  }, [onTimeout, timeoutDuration]);
};

export default useSessionTimeout;
